/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Checkbox from 'DesignSystem/Checkbox/index'
import React from 'react'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Content({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content/AddressInput/UsePatient/Content"
  
}) {
let questionAnswerUsepatientAnswerValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'answer.usePatient.answer',
})
let dtColorsBlue700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.blue.700'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let onClick = fromHelpers.useOnChange({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<Checkbox
  viewPath={`${viewPath}/Checkbox`}
 backgroundColorSelected={dtColorsBlue700}
 borderColorSelected={dtColorsBlue700}
 borderColorHovered={dtColorsBlue700}
 data="question.answer.usePatient.answer"
 isSelected={questionAnswerUsepatientAnswerValueData}
 marginTop={dtSpaceS}
 onClick={onClick}
 text="Use Patient Address"
/>
{children}
</React.Fragment>)
}